import React, { useEffect, useReducer, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    streamName: '',
    loading: false,
}

const EditStream = ({streamInfo}) => {

    const [currentNotify, setNotify] = useState(null);
    const {getClasses} = useConfig();

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if(streamInfo){
            dispatch({type: 'streamName', value: streamInfo.stream_name});
        }
    }
    , [streamInfo]);

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }

        if(state.streamName.length === 0){
            setNotify(<Notification type='danger' message="Please fill in all fields."/>);
            return;
        }

        dispatch({type: 'loading', value: true});
        const server_response = await ajaxConfig.updateStream(streamInfo.stream_id, state.streamName);
        dispatch({type: 'loading', value: false});
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);

            getClasses(true);
           
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);

        }

    }


     

  

    return (
        <div className="card-body">

            <CallOut 
                title={`Edit Class Stream`}
                description={`Stream names should begin with the class name.`}
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                        <TextInput
                            type="text"
                            label="Stream Name"
                            placeholder="Stream Name"
                            leftIcon="fa fa-school"
                            value={state.streamName}
                            onChange={e => dispatch({type: 'streamName', value: e.target.value})}
                            required
                            wrap
                            />
                        

                            <div className="text-right">
                               {!state.loading && <button type="submit" className="btn btn-lg btn-primary">Save Changes</button>}
                               {state.loading && <ActivityLoader />}
                            </div>

                        </form> 


        </div>
    );
};

export default EditStream;